import React from 'react';
import { Link } from 'react-router-dom';

export default function NavBarElementMobile({
  path,
  text,
  handleClick,
  id,
  setShowMenu,
}) {
  return (
    <li className='active'>
      <Link
        onClick={(e) => {
          e.preventDefault();
          setShowMenu(false); // Close the mobile menu
          handleClick(id);
        }}
        className='block text-3xl px-2 py-4 text-yellow-500  font-normal'
        to={path}
      >
        {text}
      </Link>
    </li>
  );
}
